import styled from 'styled-components';
import * as React from 'react';
import { Select } from '../Select';
import { NoneButton } from '../AttachmentTag';
import { IconButton } from '../IconButton';
import Arrow from '../icons/project-icons/Arrow';

export const OutputDeviceProfileButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
`;

export const SnapInDescription = styled.p`
  font-size: 12px;
  margin: 10px 0 0 0;
  max-width: 131px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const PressProfileButton = styled(NoneButton)<{ active: boolean }>`
  width: 120px;
  padding: 10px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background3} !important;
  margin-bottom: 12px;
  text-align: center;
  user-select: none;
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  color: ${({ theme }) => theme.colors.font1};
`;

export const BuzzerPlayButton = styled(IconButton)`
  svg {
    path {
      fill: ${({ theme }) => theme.colors.confPanel};
    }
  }
`;

export const ConfigurationArrowsContainer = styled.div`
  position: relative;
  svg {
    path[stroke] {
      stroke: ${({ theme }) => theme.colors.confPanel};
    }

    path[fill]:not([fill='transparent']) {
      fill: ${({ theme }) => theme.colors.confPanel};
    }
  }
`;

export const SoundSelectorCointainer = styled.div`
  display: flex;
  width: 100%;
`;

export const SoundSelector = styled(Select)`
  flex: 1;
  height: 44px;

  & > div {
    height: 100%;

    & > div {
      height: 100%;
      border: 0;
      font-size: 12px;
    }
  }

  .input:hover,
  .input:focus {
    border: 0;
  }

  .select--select-arrow {
    top: 13px;
  }
`;

export const SceneTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const DockRenderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FixedHeaderColumn = styled.div`
  flex: 0 0 184px;
  position: absolute;
  left: 0;
  color: ${({ theme }) => theme.colors.font1};
  user-select: none;
`;

export const ScrollableWrapper = styled.div<{
  flexBasis?: string;
  position?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  verticalAutoMargin?: boolean;
}>`
  flex: ${({ flexBasis = '264' }) => `0 0 ${flexBasis}px`};
  position: ${({ position = 'relative' }) => position};
  display: ${({ display = 'static' }) => display};
  align-items: ${({ alignItems = '' }) => alignItems};
  justify-content: ${({ justifyContent = '' }) => justifyContent};
  margin: ${({ verticalAutoMargin }) =>
    verticalAutoMargin ? 'unset' : 'auto'} \`} unset;
  color: ${({ theme }) => theme.colors.font1};
`;

export const OutputDeviceProfileContainer = styled.div`
  display: flex;
  margin-left: 72px;
`;

export const Row = styled.div`
  padding-bottom: 48px;
`;

export const FlexContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const ConnectionDeviceButtonWrapper = styled.div`
  margin: 8px 0;
`;

export const MainContainer = styled.div`
  position: relative;
  min-height: 100%;
  padding-top: 16px;
  display: flex;
`;

export const SnapInImageContainer = styled.div`
  position: relative;
`;

export const StyledScrollableContainer = styled.div<{
  verticalSeparator: boolean;
}>`
  overflow-x: auto;
  overflow-y: visible;
  margin-left: 184px;
  flex: 1;
  border-left: 2px solid;
  border-color: ${({ theme, verticalSeparator }) =>
    verticalSeparator ? `${theme.colors.background}25` : 'transparent'};
  transition: all 0.1s;
`;

export const ScrollableContainer = props => {
  const { children } = props;
  const [
    verticalSeparatorVisible,
    setVerticalSeparatorVisible
  ] = React.useState(false);

  return (
    <StyledScrollableContainer
      verticalSeparator={verticalSeparatorVisible}
      onScroll={event =>
        setVerticalSeparatorVisible(event.currentTarget.scrollLeft !== 0)
      }
    >
      {children}
    </StyledScrollableContainer>
  );
};

const RoomToggleName = styled(FixedHeaderColumn)`
  display: flex;
`;

const RoomToggleMainContainer = styled.div`
  height: 72px;
  cursor: pointer;
`;

const ArrowContainer = styled.div<{ opened: boolean }>`
  transform: ${({ opened }) => `rotate(${opened ? '0' : '-90'}deg)`};
  margin-right: 8px;
  transition: all 0.3s;
`;

export const RoomToggle = props => {
  const { onClick, roomName, opened } = props;

  return (
    <RoomToggleMainContainer
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <RoomToggleName>
        <ArrowContainer opened={opened}>
          <Arrow />
        </ArrowContainer>
        {roomName}
      </RoomToggleName>
    </RoomToggleMainContainer>
  );
};
